import { render, staticRenderFns } from "./ButtonWithMenu.vue?vue&type=template&id=29bceb32&scoped=true"
import script from "./ButtonWithMenu.vue?vue&type=script&lang=js"
export * from "./ButtonWithMenu.vue?vue&type=script&lang=js"
import style0 from "./ButtonWithMenu.vue?vue&type=style&index=0&id=29bceb32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bceb32",
  null
  
)

export default component.exports